import { createCustomEventSystem } from '@frontend/event';

interface ScheduleCustomEvents {
  'schedule:post-login': null;
}

const {
  triggerCustomEvent: triggerScheduleCustomEvent,
  useCustomEventListener: useScheduleCustomEventListener,
  addCustomEventListener: addScheduleCustomEventListener,
} = createCustomEventSystem<ScheduleCustomEvents>();

export { triggerScheduleCustomEvent, useScheduleCustomEventListener, addScheduleCustomEventListener };
